import styled from "styled-components";

export const BlockWishList = styled.div`
  border-radius: 8px;
  width: 84%;
  max-height: 90vh;
  overflow: auto;
  position: relative;
  display: flex;
  flex-direction: column;

  ::-webkit-scrollbar {
    width: 8px;
    background-color: ${(props) => props.theme.colors.brand1.pure};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${(props) => props.theme.colors.brand4.dark};
  }

  @media (min-width: 480px) {
    width: 300px;
  }

  @media (min-width: 1366px) {
    width: 20%;
  }

  > img {
    border-radius: 8px 0 0;
    width: 100%;
    height: auto;
  }
`;

export const Content = styled.div`
  background-color: ${(props) => props.theme.colors.brand4.dark};
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  align-items: center;
  gap: 10px;
  padding: 12px;

  @media (min-width: 380px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 20px;
  }

  @media (min-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 768px) {
    padding: 20px;
  }
`;

export const Informations = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  > h6,
  p {
    font-weight: 550;
    font-size: 0.625rem;
    line-height: auto;
    color: ${(props) => props.color || props.theme.colors.typography1.pure};

    @media (min-width: 768px) {
      font-weight: 500;
      font-size: 0.625rem;
      line-height: 12px;
    }
  }

  > small {
    font-weight: 500;
    font-size: 0.5rem;
    color: ${(props) => props.color || props.theme.colors.typography1.dark};

    @media (min-width: 768px) {
      font-size: 0.5rem;
      line-height: 10px;
    }
  }
`;

export const PricesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (min-width: 768px) {
    margin: 4px 0 0;
  }

  .p__old__value {
    text-decoration: line-through;
  }

  .p__discount {
    font-family: "flama-medium";
    font-size: 0.688rem;

    @media (min-width: 480px) {
      ffont-size: 0.938rem;
    }

    @media (min-width: 768px) {
      font-size: 0.688rem;
    }
  }
`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  @media (min-width: 768px) {
    gap: 16px;
  }

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    border: none;
    padding: 18px;

    :hover {
      opacity: 0.4;
    }

    > svg {
      width: 20px;
      height: 20px;
    }
  }

  .card__dowload {
    background-color: transparent;
    border: 1px solid
      ${(props) => props.color || props.theme.colors.typography1.pure};
  }

  .card__share {
    background: ${(props) => props.color || props.theme.colors.brand1.pure};
  }
`;
export const ExiteButtonCard = styled.div`
  position: absolute;
  cursor: pointer;
  top: 24px;
  right: 24px;

  .svg__exit_image--button {
    width: 13px;
    height: 13px;
  }
`;
